import type { FlowTypes, FlowConfig } from '@logistiek-zonder-papier/lzp-library'

export type Flow = { type: FlowTypes | string; label: string; description: string }
export type CreateFlowConfig = Omit<FlowConfig, 'id' | 'subAppId' | 'order'>

export function createEmptyConfig(): CreateFlowConfig {
  return {
    label: '',
    description: '',
    hidden: false,
    requiresRegistration: false,
    pages: [],
    type: '',
    buttonColour: '#000000',
    textColour: '#ffffff',
    predicates: [],
    predicateCombinator: 'AND',
    activityIndicatorPath: null,
    activityIndicatorColour: null,
    activityIndicatorTextColour: null,
  }
}
